import { Button } from '@/components/ui/button';

interface ActionButtonProps {
  href?: string;
  onClick?: () => void;
  label: string;
  disabled?: boolean;
  title?: string;
}

export function ActionButton({ href, onClick, label, disabled, title }: ActionButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (href) {
      window.open(href, '_blank');
    }
  };

  return (
    <Button
      onClick={handleClick}
      variant="outline"
      className="w-full"
      disabled={disabled}
      title={title}
    >
      {label}
    </Button>
  );
}
